module.exports = __webpack_public_path__ + "img/UTKODA-11.042ece9d.jpg";